export default __webpack_public_path__ + "static/media/hero-2.0c181d18.svg";